import React, {Component, PropTypes} from 'react';
import IconButton from 'material-ui/IconButton/IconButton';
import CloseIcon from 'material-ui/svg-icons/navigation/close';

const CloseButton = (props) => (
    <IconButton {...props}>
    <CloseIcon/></IconButton>
);


export default CloseButton;


/** WEBPACK FOOTER **
 ** ./app-react/components/Buttons/CloseButton.jsx
 **/